import { Injectable } from '@angular/core';
import { IGeoAddress, IGeoPosition } from '../models/geolocalization.interface';
import { EndpointsService } from './endpoints.service';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class GeolocalizationService {

  constructor(
    private httpService: HttpService,
    private endpoints: EndpointsService
  ) { }

  getLatLongFromAddress(geoaddress: IGeoAddress): Promise<string> {
    return new Promise<string>((resolve) => {
      this.httpService.post(this.endpoints.geolocalization, geoaddress).subscribe({
        next: (response: any) => {
          if (response.success) {
            let position: IGeoPosition = {
              latitude: response.data.lat,
              longitude: response.data.lng
            }
            resolve(`${position.longitude} ${position.latitude}`);
          } else {
            resolve(`Error: ${response.message}`);
          }
        }, error: (err) => {
          if (err.error.message) {
            resolve(`Error: ${err.error.message}`);
          } else {
            resolve('Error: Ocurrió un error con el servicio de geolocalización.');
          }
        }
      })
    });
  }

}
